import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Inject,
  Input,
  ViewChild,
  AfterViewInit
} from '@angular/core';
// import { FormControl, FormGroup } from '@angular/forms';
import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { select, Store } from '@ngrx/store';
import {
  getAutomationCurrentConnectorBots,
  getAutomationCurrentConnectorDevices,
  getAutomationCurrentRpaPoolDevices,
  getAutomationCurrentRpaUsers,
  getIsLoadingDevices,
  getIsLoadingBots,
  getIsLoadingPoolDevices,
  getIsLoadingUsers
} from '../store/selectors/rpa-automation-anywhere-conn.selector';
import { Observable } from 'rxjs';
import { IAppState } from 'app/IAppState';
import { IRPAAutomationAnywhereBot, IRPAAutomationAnywhereBots, IRPAAutomationAnywhereDevice, IRPAAutomationAnywherePoolDevice, IRPAAutomationAnywhereUser, IRpaConnectionAutomationAnywhere } from 'app/rpa-bots/core/IRpaBots';

@Component({
  selector: 'biz-edit-bot',
  templateUrl: './edit-bot.component.html',
  styleUrls: ['./edit-bot.component.scss']
})
export class EditBotComponent implements OnInit, AfterViewInit {
  @Output() save = new EventEmitter<any>();
  process: IRPAAutomationAnywhereBots;
  selectedBotOption: any;
  selectedDeviceOption: string;
  selectedPoolDeviceOption: string[];
  selectedUserOption: number;
  originalProcess: IRPAAutomationAnywhereBots;
  originalConnection: IRpaConnectionAutomationAnywhere;
  selectedOverrideDefaultDeviceOption: boolean;
  automationAnywhereConnection$: Observable<IRpaConnectionAutomationAnywhere>;
  automationAnywhereBots$: Observable<IRPAAutomationAnywhereBot[]>;
  automationAnywhereBotsSub: any;
  automationAnywhereDevices$: Observable<IRPAAutomationAnywhereDevice[]>;
  automationAnywhereDevicesSub: any;
  automationAnywherePoolDevices$: Observable<
    IRPAAutomationAnywherePoolDevice[]
  >;
  automationAnywherePoolDevicesSub: any;
  automationAnywhereUsers$: Observable<IRPAAutomationAnywhereUser[]>;
  automationAnywhereUsersSub: any;
  automationAnywhereVersion: string;

  currentConnection: IRpaConnectionAutomationAnywhere;
  isLoadingDevices$: Observable<boolean>;
  isLoadingPoolDevices$: Observable<boolean>;
  isLoadingUsers$: Observable<boolean>;
  isLoadingBots$: Observable<boolean>;
  availableDevices: IRPAAutomationAnywhereDevice[];
  availablePoolDevices: IRPAAutomationAnywherePoolDevice[];
  availableUsers: IRPAAutomationAnywhereUser[];
  availableBots: any;
  listPoolDevices: any;

  constructor(
    private _modalRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public initialData: any,
    private _store: Store<IAppState>
  ) {
    this.automationAnywhereBots$ = this._store.pipe(
      select(getAutomationCurrentConnectorBots)
    );
    this.automationAnywhereDevicesSub = this.automationAnywhereBots$
      .pipe()
      .subscribe(bots => {
        this.availableBots = bots;
      });
    this.automationAnywhereDevices$ = this._store.pipe(
      select(getAutomationCurrentConnectorDevices)
    );
    this.automationAnywhereBotsSub = this.automationAnywhereDevices$
      .pipe()
      .subscribe(devices => {
        this.availableDevices = devices;
      });

    this.automationAnywherePoolDevices$ = this._store.pipe(
      select(getAutomationCurrentRpaPoolDevices)
    );
    this.automationAnywherePoolDevicesSub = this.automationAnywherePoolDevices$
      .pipe()
      .subscribe(poolDevices => {
        this.availablePoolDevices = poolDevices;
        if (this.availablePoolDevices) {
          this.listPoolDevices = this.buildPoolDevices();
        }
      });

    this.automationAnywhereUsers$ = this._store.pipe(
      select(getAutomationCurrentRpaUsers)
    );
    this.automationAnywhereUsersSub = this.automationAnywhereUsers$
      .pipe()
      .subscribe(users => {
        this.availableUsers = users;
      });

    this.originalProcess = _.cloneDeep(initialData.process);
    this.originalConnection = initialData.connection;
    this.isLoadingBots$ = this._store.pipe(select(getIsLoadingBots));

    if (this.originalConnection.version && this.originalConnection.version.startsWith("11.3")) {
      this.isLoadingDevices$ = this._store.pipe(select(getIsLoadingDevices));
    } else {
      this.automationAnywhereVersion = this.originalConnection.version;
      this.isLoadingUsers$ = this._store.pipe(select(getIsLoadingUsers));
      this.isLoadingPoolDevices$ = this._store.pipe(
        select(getIsLoadingPoolDevices)
      );
    }

    if (this.originalProcess.poolDeviceIds) {
      this.selectedPoolDeviceOption = this.originalProcess.poolDeviceIds;
    }

    this.process = initialData.process;
    this.selectedBotOption = this.originalProcess.botId;
    this.selectedOverrideDefaultDeviceOption = this.originalProcess.overrideDefaultDevice;
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.loadData();
  }

  ngOnDestroy() {
    if (this.automationAnywhereBots$) {
      this.automationAnywhereBotsSub.unsubscribe();
    }
    if (this.automationAnywhereDevices$) {
      this.automationAnywhereDevicesSub.unsubscribe();
    }

    if (this.automationAnywhereUsers$) {
      this.automationAnywhereUsersSub.unsubscribe();
    }
    if (this.automationAnywherePoolDevices$) {
      this.automationAnywherePoolDevicesSub.unsubscribe();
    }
  }

  loadData() {
    if (this.originalProcess.deviceIds) {
      this.selectedDeviceOption = this.originalProcess.deviceIds[0];
    }

    if (this.availablePoolDevices) {
      this.listPoolDevices = this.buildPoolDevices();
    }

    if (this.originalProcess.userIds) {
      this.selectedUserOption = this.originalProcess.userIds[0];
    }
  }

  buildPoolDevices() {
    const listData = [];
    this.availablePoolDevices.forEach(
      (poolDevice: IRPAAutomationAnywherePoolDevice) => {
        let existItem = false;
        if (this.selectedPoolDeviceOption) {
          this.selectedPoolDeviceOption.forEach((idPoolDevice: string) => {
            if (poolDevice.id === idPoolDevice) {
              existItem = true;
            }
          });
        } else {
          this.selectedPoolDeviceOption = [];
        }
        const item = {
          checked: existItem,
          id: poolDevice.id,
          name: poolDevice.name,
          status: poolDevice.status
        };
        listData.push(item);
      }
    );
    return listData;
  }

  saveProcess() {
    this.process.botId = this.selectedBotOption;
    this.process.overrideDefaultDevice = this.selectedOverrideDefaultDeviceOption;
    if (!this.process.deviceIds) {
      this.process.deviceIds = [];
      this.process.deviceIds.push(this.selectedDeviceOption);
    } else {
      this.process.deviceIds[0] = this.selectedDeviceOption;
    }

    if (!this.process.userIds) {
      this.process.userIds = [];
      this.process.userIds.push(this.selectedUserOption);
    } else {
      this.process.userIds[0] = this.selectedUserOption;
    }

    if (!this.process.poolDeviceIds) {
      this.process.poolDeviceIds = [];
      this.process.poolDeviceIds = this.selectedPoolDeviceOption;
    } else {
      this.process.poolDeviceIds = this.selectedPoolDeviceOption;
    }
    if (!_.isEqual(this.originalProcess, this.process)) {
      this._modalRef.close(this.process);
    } else {
      this._modalRef.close();
    }
  }

  setSelectedBot(item: string) {
    this.selectedBotOption = item;
  }

  setSelectedOverrideDefaultDevice(item: any) {
    this.selectedOverrideDefaultDeviceOption = item.target.checked;
  }

  setSelectedDevice(item: any) {
    this.selectedDeviceOption = item.id;
  }

  setSelectedPoolDevices(item: any, checked: any) {
    this.listPoolDevices.forEach((poolDevice: any) => {
      if (item.id === poolDevice.id) {
        poolDevice.checked = checked.target.checked;
      }
    });

    if (checked.target.checked) {
      const existItem = false;
      // TODO: This service is not used
      this.selectedPoolDeviceOption.forEach((idPoolDevice: string) => {
        if (item.id === idPoolDevice) {
          existItem;
        }
      });
      if (!existItem) {
        this.selectedPoolDeviceOption.push(item.id);
      }
    } else {
      this.selectedPoolDeviceOption.forEach(
        (idPoolDevice: string, index: number) => {
          if (item.id === idPoolDevice) {
            this.selectedPoolDeviceOption.splice(index, 1);
          }
        }
      );
    }
  }

  setSelectedUser(item: number) {
    this.selectedUserOption = item;
  }

  validatePoolDeviceSelected(item: string) {
    let out = false;
    this.selectedPoolDeviceOption.forEach((idPoolDevice: string) => {
      if (item === idPoolDevice) {
        out = true;
      }
    });
    return out;
  }

  isVersion11_3():boolean{
    return this.automationAnywhereVersion && this.automationAnywhereVersion.startsWith("11.3");
  }
}
